






















































import { LocaleMessageObject, TranslateResult }              from 'vue-i18n';
import { TooltipConfiguration, tooltipDefaultConfiguration } from '@/components/tooltip/tooltip.config';
import { computed, defineComponent, PropType }               from '@vue/composition-api';
import { Computed }                                          from '@/types';
import useGlobalTranslations                                 from '@/hooks/use-global-translations';
import useTooltipVisibility                                  from '@/components/tooltip/hooks/use-tooltip-visibility';
import cIconTrashCan                                         from '@/components/icons/icon-trash-can.component.vue';
import cTooltip                                              from '@/components/tooltip/tooltip.component.vue';

interface TransferredTranslation {
  question: string;
  confirmation: string;
  resignation: string;

  [ k: string ]: string;
}

export default defineComponent({
  name: 'cElementWithConfirmation',
  components: {
    cIconTrashCan,
    cTooltip,
  },
  props: {
    tooltipConfiguration: {
      type: Object as PropType<TooltipConfiguration>,
      default: () => tooltipDefaultConfiguration,
    },
    translation: {
      type: Object as PropType<Partial<TransferredTranslation>>,
      default: () => ({
        question: '',
        confirmation: '',
        resignation: '',
      }),
    },
  },
  setup(props, context) {
    const elementWithConfirmation = useGlobalTranslations('elementWithConfirmation') as LocaleMessageObject;
    const tooltipRelatedTargetId = 'action-confirm';

    const {
      setTooltipVisibility,
      tooltipVisibility,
      tooltipReference,
      tooltipFocusout,
    } = useTooltipVisibility([ tooltipRelatedTargetId ]);

    const getProperTranslation: Computed<(type: string) => TranslateResult> = computed(() => (
      (type: string) => (props.translation[ type ] ? props.translation[ type ] : elementWithConfirmation[ type ])
    ));

    const handleConfirmation = (): void => {
      context.emit('handleConfirmation');
      setTooltipVisibility(false);
      (tooltipReference.value as HTMLElement).blur();
    };

    const handleResignation = (): void => {
      context.emit('handleResignation');
      setTooltipVisibility(false);
      (tooltipReference.value as HTMLElement).blur();
    };

    return {
      slots: context.slots,
      elementWithConfirmation,
      setTooltipVisibility,
      tooltipVisibility,
      tooltipReference,
      tooltipFocusout,
      getProperTranslation,
      tooltipRelatedTargetId,
      handleConfirmation,
      handleResignation,
    };
  },
});
